import { MButton } from "../MButton"
import { BottomMobNavBarStyled } from "./BottomMobNavBar"

export const BottomBookingBar = (props) => {
  return (
    <BottomMobNavBarStyled>
      <div className="container" style={{ padding: "8px 16px" }}>
        <div>{props.minPrice && <div>od {props.minPrice} zł / godz</div>}</div>
        <div style={{ flex: 1, textAlign: "right" }}>
          <MButton
            variant="contained"
            color="primary"
            label="Sprawdź dostępność"
            onClick={props.onShowCalendar}
          />
        </div>
      </div>
    </BottomMobNavBarStyled>
  )
}
